(function(){
  'use strict';

  var PANEL_ATTR = 'data-ugg-conversion-cart';
  var PRODUCT_ATTR = 'data-ugg-conversion-product';
  var timer = null;

  function isFrench(){ return /^fr\b/i.test(document.documentElement.lang || ''); }
  function rootPath(){
    var base = (window.theme && window.theme.routes && window.theme.routes.root) || '/';
    return base.charAt(base.length - 1) === '/' ? base : base + '/';
  }
  function cartEndpoint(){ return rootPath() + 'cart.js'; }
  function collectionUrl(){ return rootPath() + 'collections/ugg#ugg-products'; }
  function esc(v){
    return String(v == null ? '' : v).replace(/[&<>\'"]/g, function(ch){
      return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch];
    });
  }
  function handleFromUrl(url){
    var match = String(url || '').match(/\/products\/([^?#/]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  }
  function getCatalog(){
    var node = document.getElementById('ugg-conversion-catalog');
    if(!node) return [];
    try { return JSON.parse(node.textContent || '[]'); } catch(e) { return []; }
  }
  var catalog = getCatalog();

  function catalogProduct(handle){
    return catalog.find(function(p){ return p.handle === handle; }) || null;
  }
  function isUggHandle(handle){
    return !!catalogProduct(handle) || /(^|-)ugg-/i.test(handle || '');
  }
  function isUggItem(item){
    var handle = item.handle || item.product_handle || handleFromUrl(item.url);
    return isUggHandle(handle) || /^UGG\b/i.test(item.product_title || '');
  }
  function cardMarkup(product, compact){
    if(!product) return '';
    var fr = isFrench();
    var img = product.image ? '<img src="'+esc(product.image)+'" alt="'+esc(product.title)+'" loading="lazy">' : '<span class="ugg-conversion-card-placeholder"></span>';
    return '<a class="ugg-conversion-card'+(compact?' is-compact':'')+'" href="'+esc(product.url)+'">'+
      '<span class="ugg-conversion-card-image">'+img+'<span class="ugg-conversion-card-badge">'+(fr?'DUO −30 %*':'DUO −30%*')+'</span></span>'+
      '<span class="ugg-conversion-card-copy"><strong>'+esc(product.title)+'</strong><span class="ugg-conversion-card-price">'+esc(product.priceLabel || '')+'</span>'+
      '<span class="ugg-conversion-card-cta">'+(fr?'Choisir comme 2e paire':'Choose as pair 2')+' →</span></span></a>';
  }
  function recommendations(excludeHandles, limit){
    var blocked = {};
    (excludeHandles || []).forEach(function(h){ blocked[h] = true; });
    return catalog.filter(function(p){ return p.available !== false && !blocked[p.handle]; }).slice(0, limit || 4);
  }
  function benefitsMarkup(){
    var fr = isFrench();
    return '<div class="ugg-conversion-benefits">'+
      '<span>✓ '+(fr?'Livraison rapide & suivie':'Fast & tracked shipping')+'</span>'+
      '<span>✓ '+(fr?'Paiement sécurisé':'Secure checkout')+'</span>'+
      '<span>✓ '+(fr?'Assistance retour':'Return support')+'</span>'+
      '<span>✓ '+(fr?'Remises automatiques':'Automatic savings')+'</span>'+
    '</div>';
  }

  function insertSlimBanner(){
    if(document.querySelector('.ugg-conversion-slim-banner')) return;
    var fr = isFrench();
    var slim = document.createElement('div');
    slim.className = 'ugg-conversion-slim-banner';
    slim.innerHTML = '<strong>'+(fr?'1 paire : 20 % de réduction · 2 paires : 30 % de réduction':'1 pair: 20% off · 2 pairs: 30% off')+'</strong>'+
      '<span>'+(fr?'Réduction automatique : 20 % sur une paire et 30 % sur chacune des deux paires UGG. Aucun code requis.'
        :'Automatic savings: 20% off one eligible UGG pair or 30% off both eligible UGG pairs. No code needed.')+'</span>';

    var productMain = document.querySelector('.template-product .product-single, .template-product .product, .template-product [data-product-single]');
    var mainWrap = document.querySelector('.template-product main, .template-product .main-content, .template-product [role="main"]');
    if(productMain && productMain.parentNode){
      productMain.parentNode.insertBefore(slim, productMain);
    } else if(mainWrap) {
      mainWrap.insertBefore(slim, mainWrap.firstChild);
    }
  }

  function initProductOffer(){
    var pathHandle = handleFromUrl(location.pathname);
    if(!pathHandle || !isUggHandle(pathHandle)) return;

    document.documentElement.classList.add('ugg-conversion-enhanced-ready');
    document.body.classList.add('ugg-conversion-product');
    insertSlimBanner();

    var details = document.querySelector('.product-single__details .form__wrapper');
    if(!details || details.querySelector('['+PRODUCT_ATTR+']')) return;

    var formBlock = details.querySelector('.product__form__wrapper');
    if(!formBlock) return;

    var fr = isFrench();
    var mini = document.createElement('div');
    mini.className = 'ugg-conversion-product-mini';
    mini.setAttribute(PRODUCT_ATTR,'');
    mini.innerHTML =
      '<div class="ugg-conversion-mini-copy">'+
        '<span class="ugg-conversion-eyebrow">'+(fr?'OFFRE DUO UGG':'UGG DUO OFFER')+'</span>'+
        '<p>'+(fr?'Votre paire bénéficie déjà de <strong>−20 %</strong>. Ajoutez une 2e paire UGG pour obtenir <strong>−30 %</strong> sur les deux.'
          :'Your UGG pair gets <strong>20% off</strong>. Add a second eligible pair to get <strong>30% off both pairs</strong>.')+'</p>'+
      '</div>';

    formBlock.parentNode.insertBefore(mini, formBlock);

    var submit = formBlock.querySelector('.product__submit__holder');
    if(submit && !submit.querySelector('.ugg-conversion-auto-note')){
      var note = document.createElement('p');
      note.className = 'ugg-conversion-auto-note';
      note.textContent = fr ? '✓ Votre réduction de 20 % s’applique automatiquement dans le panier.' : '✓ Your 20% saving applies automatically in the cart.';
      submit.appendChild(note);
    }

    var recs = recommendations([pathHandle], 4);
    if(recs.length){
      var block = document.createElement('section');
      block.className = 'ugg-conversion-product-recs compact';
      block.innerHTML =
        '<div class="ugg-conversion-recs-head"><div><span class="ugg-conversion-eyebrow">'+(fr?'COMPLÉTEZ VOTRE DUO':'COMPLETE YOUR DUO')+'</span>'+
        '<h3>'+(fr?'Ajoutez une deuxième paire et économisez davantage':'Add a second pair and save more')+'</h3>'+
        '<p>'+(fr?'Choisissez une autre paire UGG. Les deux paires bénéficient automatiquement de 30 % de réduction.'
          :'Choose another UGG pair. Both eligible UGG pairs automatically get 30% off.')+'</p></div>'+
        '<a href="'+esc(collectionUrl())+'">'+(fr?'Voir tous les produits UGG':'See all UGG products')+' →</a></div>'+
        '<div class="ugg-conversion-card-row">'+recs.map(function(p){return cardMarkup(p,false);}).join('')+'</div>'+
        '<p class="ugg-conversion-disclaimer">* '+(fr?'La remise de 30 % s’applique aux deux paires UGG éligibles lorsque deux paires sont au panier.'
          :'30% applies to both eligible UGG pairs when two pairs are in the cart.')+'</p>';
      formBlock.insertAdjacentElement('afterend', block);
    }
  }

  function cartState(cart){
    var items = (cart && cart.items) || [];
    var ugg = items.filter(isUggItem);
    var qty = ugg.reduce(function(sum,item){ return sum + Number(item.quantity || 0); },0);
    var handles = ugg.map(function(item){ return item.handle || item.product_handle || handleFromUrl(item.url); }).filter(Boolean);
    return {qty:qty, handles:handles};
  }
  function cartPanelMarkup(cart){
    var state = cartState(cart);
    if(!state.qty) return '';
    var fr = isFrench();
    if(state.qty >= 2){
      return '<div class="ugg-conversion-cart-success">'+
        '<span class="ugg-conversion-eyebrow">'+(fr?'DUO DÉBLOQUÉ':'DUO UNLOCKED')+'</span>'+
        '<h3>'+(fr?'Votre offre Duo UGG est activée.' :'Your UGG Duo offer is activated.')+'</h3>'+
        '<p>'+(fr?'−30 % sur chacune des deux paires UGG. Les remises s’appliquent automatiquement.'
          :'30% off both eligible UGG pairs. Savings apply automatically.')+'</p>'+
        benefitsMarkup()+
      '</div>';
    }

    var recs = recommendations(state.handles, 3);
    return '<div class="ugg-conversion-cart-offer">'+
      '<span class="ugg-conversion-eyebrow">'+(fr?'VOUS AVEZ DÉJÀ GAGNÉ −20 %':'YOU’VE ALREADY UNLOCKED 20% OFF')+'</span>'+
      '<h3>'+(fr?'Votre première paire UGG est déjà à −20 %.' :'Your first UGG pair is already 20% off.')+'</h3>'+
      '<p>'+(fr?'Ajoutez une deuxième paire UGG : les deux paires passent à −30 %, automatiquement et sans code.'
        :'Add a second eligible UGG pair and get 30% off both automatically — no code needed.')+'</p>'+
      '<div class="ugg-conversion-cart-meter"><span class="is-done">✓ '+(fr?'Paire 1 : −20 %':'Pair 1: 20% off')+'</span><span>→</span><span class="is-next">'+(fr?'Deux paires : −30 % chacune':'Two pairs: 30% off both')+'</span></div>'+
      benefitsMarkup()+
      (recs.length ? '<div class="ugg-conversion-cart-recs"><div class="ugg-conversion-cart-recs-title">'+(fr?'Ajoutez votre 2e paire maintenant':'Add your second pair now')+'</div><div class="ugg-conversion-card-row is-cart">'+recs.map(function(p){return cardMarkup(p,true);}).join('')+'</div></div>' : '')+
      '<a class="ugg-conversion-all-link" href="'+esc(collectionUrl())+'">'+(fr?'Voir toutes les paires UGG':'Shop all UGG pairs')+' →</a>'+
      '<p class="ugg-conversion-disclaimer">* '+(fr?'La remise de 30 % s’applique aux deux paires UGG éligibles lorsque deux paires sont au panier.'
        :'30% applies to both eligible UGG pairs when two pairs are in the cart.')+'</p>'+
    '</div>';
  }
  function placeCartPanel(target, cart, beforeNode){
    if(!target) return;
    var html = cartPanelMarkup(cart);
    var existing = target.querySelector('['+PANEL_ATTR+']');
    if(!html){
      if(existing) existing.remove();
      return;
    }
    if(!existing){
      existing = document.createElement('div');
      existing.className = 'ugg-conversion-cart-panel';
      existing.setAttribute(PANEL_ATTR,'');
      if(beforeNode && beforeNode.parentNode === target) target.insertBefore(existing,beforeNode);
      else target.insertBefore(existing,target.firstChild);
    }
    existing.innerHTML = html;
  }
  function refreshCartPanels(){
    fetch(cartEndpoint(),{headers:{Accept:'application/json'}}).then(function(r){
      if(!r.ok) return null;
      return r.json();
    }).then(function(cart){
      if(!cart) return;
      document.documentElement.classList.add('ugg-conversion-enhanced-ready');
      Array.prototype.forEach.call(document.querySelectorAll('[data-cart-drawer-body]'),function(body){
        placeCartPanel(body,cart,body.querySelector('.cart__errors') || body.firstChild);
      });
      var cartContent = document.querySelector('[data-cart-page] .cart__content');
      if(cartContent) placeCartPanel(cartContent,cart,cartContent.querySelector('.cart__items__wrapper'));
    }).catch(function(){});
  }
  function scheduleRefresh(delay){
    clearTimeout(timer);
    timer = setTimeout(refreshCartPanels, typeof delay === 'number' ? delay : 180);
  }
  function init(){
    catalog = getCatalog();
    if(!catalog.length) return;
    document.documentElement.classList.add('ugg-conversion-enhanced-ready');
    initProductOffer();
    scheduleRefresh(60);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init);
  else init();

  document.addEventListener('shopify:section:load',function(){ initProductOffer(); scheduleRefresh(80); });

  var baseFetch = window.fetch;
  if(baseFetch && !window.__uggConversionEnhancedFetchWrapped){
    window.__uggConversionEnhancedFetchWrapped = true;
    window.fetch = function(){
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : ((args[0] && args[0].url) || '');
      var result = baseFetch.apply(this,args);
      if(/\/cart\/(add|change|update)(\.js)?(?:\?|$)/i.test(url)){
        result.finally(function(){ scheduleRefresh(220); });
      }
      return result;
    };
  }

  document.addEventListener('click',function(e){
    if(e.target && e.target.closest && e.target.closest('[data-cart-drawer-toggle],[data-quantity-button],[data-item-remove]')) scheduleRefresh(220);
  },true);

  var observer = new MutationObserver(function(mutations){
    var relevant = mutations.some(function(m){
      return Array.prototype.some.call(m.addedNodes || [],function(n){
        return n.nodeType === 1 && ((n.matches && n.matches('[data-cart-drawer-body],[data-cart-page]')) || (n.querySelector && n.querySelector('[data-cart-drawer-body],[data-cart-page]')));
      });
    });
    if(relevant) scheduleRefresh(120);
  });
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();
